/**
 * Created by AI assistant on 13.02.26.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export const markdownDocVisibility = {
    "internal": {
        name: "Internal",
    },
    "public": {
        name: "Public",
    },
};

export default declareLinkedEntity({
    entity: "flowDefMarkdownDocs",
    graphQL: "FlowDefMarkdownDoc",
    name: "Flow Definition Markdown Documentation",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowDefMarkdownDocs",
    defaultTitle: (data) => {
        return data['title'] || data['key'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    fields: (types) => { return {
        id: {
            name: "Flow Definition Markdown Documentation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        key: {
            name: "Key",
            type: "string",
            defaultValue: "",
            trim: true,
        },
        title: {
            name: "Title",
            type: "string",
            translatable: false,
            defaultValue: "",
        },
        content: {
            name: "Markdown Content",
            type: "text",
            translatable: false,
            defaultValue: "",
        },
        order: {
            name: "Order",
            type: "int",
            defaultValue: 0,
        },
        visibility: {
            name: "Visibility",
            type: "enum",
            defaultValue: "internal",
            values: markdownDocVisibility,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: () => { return {
    }; }
});
